export default __webpack_public_path__ + "static/media/icon-logout.f8cfd7a1.svg";